import { api, type ListParams, toSearchParams } from '@/interceptors/axiosInstance.ts';
import type { AuditLog } from '@/features/auditLog/audit-log-types.ts';
import type { SpringPage } from '@/lib/SpringPage.ts';

export async function fetchAuditLogs(
  params: Partial<ListParams> = {}
): Promise<SpringPage<AuditLog>> {
  const qs = toSearchParams({
    page: params.page ?? 0,
    size: params.size ?? 20,
    sort: params.sort ?? [],
  });
  const res = await api.get<SpringPage<AuditLog>>(`/v1/audit-logs${qs ? `?${qs}` : ''}`);
  return res.data;
}

export async function fetchAuditLogById(id: number): Promise<AuditLog> {
  const res = await api.get<AuditLog>(`/v1/audit-logs/${id}`);
  return res.data;
}

export async function fetchAuditLogsByEntity(entityId: string) {
  const res = await api.get<AuditLog[]>(`/v1/audit-logs/by-entity/${entityId}`);
  return res.data;
}
